import AbstractCommand from '../AbstractCommand';
import companyBrandUpdate from '../../requests/brands/companyBrandUpdate';

/**
 *
 */
export default class UpdateCompanyBrandCommand extends AbstractCommand {
	/**
	 *
	 * @param company
	 * @param companyBrand
	 */
	constructor(company, companyBrand) {
		super();
		this.company = company;
		this.companyBrand = companyBrand;
	}

	/**
	 *
	 * @param successCallback
	 * @param failCallback
	 */
	execute(successCallback, failCallback) {
		companyBrandUpdate(this.company.id, this.companyBrand.id, this.companyBrand)
			.then((response) => {
				successCallback(response);
			})
			.catch((err) => {
				if (failCallback) {
					failCallback(err);
				}
			});
	}
}
